import { render, staticRenderFns } from "./rk-header.vue?vue&type=template&id=28ced9a5&scoped=true&"
import script from "./rk-header.vue?vue&type=script&lang=ts&"
export * from "./rk-header.vue?vue&type=script&lang=ts&"
import style0 from "./rk-header.vue?vue&type=style&index=0&id=28ced9a5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ced9a5",
  null
  
)

export default component.exports